import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'nida-web-ui-shared-password-hints',
  templateUrl: './ui-shared-password-hints.component.html',
  styleUrls: ['./ui-shared-password-hints.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class UiSharedPasswordHintsComponent {}
